import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';
import Template from './pages/Template';

import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<Template />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
